import type { FC } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import type { UploadedFilter } from '../../types/hypothesis';
import { UPLOADED_FILTER_OPTIONS } from '../../types/hypothesis';
import type { FilterSize } from './filterSize';
import { DEFAULT_FILTER_SIZE } from './filterSize';

interface UploadedFilterSelectProps {
  value: UploadedFilter;
  onChange: (val: UploadedFilter) => void;
  minWidth?: number;
  size?: FilterSize;
}

const UploadedFilterSelect: FC<UploadedFilterSelectProps> = ({
  value,
  onChange,
  minWidth = 150,
  size = DEFAULT_FILTER_SIZE,
}) => {
  return (
    <FormControl size={size} sx={{ minWidth }}>
      <InputLabel>Uploaded</InputLabel>
      <Select
        label="Uploaded"
        size={size}
        value={value}
        onChange={(e) => { onChange(e.target.value as UploadedFilter); }}
      >
        {UPLOADED_FILTER_OPTIONS.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default UploadedFilterSelect;
